import { Button, Grid, makeStyles } from "@material-ui/core";
import { Check, Delete } from "@material-ui/icons";
import { FC, useContext } from "react";
import { EditRouteStopsContext } from "./edit-route-stops.context";
import { RouteStopFragment } from "../../../api/nachfahrbarkeit-api/generated";

interface RouteDetailsMapInfoWindowButtonsProps {
  stop: RouteStopFragment;
  onSave: () => void;
}

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    margin: 0,
  },
  addButton: {
    borderWidth: 0.5,
    borderRadius: 3,
    borderColor: theme.palette.primary.main,
  },
  deleteButton: {
    borderWidth: 0.5,
    borderRadius: 3,
    borderColor: theme.palette.error.main,
  },
}));

export const RouteDetailsMapInfoWindowButtons: FC<RouteDetailsMapInfoWindowButtonsProps> = (props) => {
  const { stop, onSave } = props;
  const classes = useStyles();
  const { deleteStop, isInEditMode } = useContext(EditRouteStopsContext);

  if (!isInEditMode) {
    return null;
  }

  return (
    <Grid container item xs direction="row" className={classes.buttonContainer} justifyContent="flex-end" spacing={2}>
      <Grid item>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          className={classes.deleteButton}
          onClick={() => deleteStop(stop.id)}
        >
          <Delete color="error" />
        </Button>
      </Grid>
      <Grid item>
        <Button type="button" variant="outlined" className={classes.addButton} onClick={onSave}>
          <Check color="primary" />
        </Button>
      </Grid>
    </Grid>
  );
};
